import React from "react";

import useComponents from "../../../components";
import useControllers from "../../../../controllers";

const SettingsCreate = () => {
  const {
    ContentWrappers,
    TextFieldControlled,
    SelectFieldControlled,
    useButtons,
    Typography,
  } = useComponents();

  const { DefaultButton } = useButtons();

  const { useScreenHooks } = useControllers();
  const { useSettings } = useScreenHooks();
  const { useSettingsCreate } = useSettings();
  const {
    control,
    handleSubmit,
    onSubmit,
    isEditMode,
    errors,
    showValue,
    setShowValue,
    isSensitiveKey,
    contentType,
    setContentType,
    isPreservingSecret,
    replaceSecret,
    handleReplaceSecret,
    handleCancelReplaceSecret,
  } = useSettingsCreate();

  const contentTypeOptions = [
    { value: "string", label: "Texto (String)" },
    { value: "number", label: "Número (Number)" },
    { value: "boolean", label: "Booleano (Boolean)" },
    { value: "object", label: "Objeto (JSON)" },
  ];

  return (
    <div className="bg-white px-8 pt-10 pb-12 mx-12 rounded-lg">
      <Typography variant="h3" className="uppercase mb-8">
        {isEditMode ? "Editar Setting" : "Crear Nuevo Setting"}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentWrappers gridColums={["1fr"]} className="gap-6">
          <TextFieldControlled
            label="ID"
            placeholder="Ej: OPENAI_API_KEY, MAX_RETRIES"
            name="id"
            id="setting-id"
            control={control}
            disabled={isEditMode}
            error={errors.id?.message}
            helperText="Use UPPER_SNAKE_CASE. Ej: OPENAI_API_KEY"
          />

          {isSensitiveKey && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <Typography variant="body2" className="text-yellow-800">
                ⚠️ Este setting es una credencial sensible. Se guarda oculta y la
                API nunca la devuelve en texto plano.
              </Typography>
            </div>
          )}

          {isPreservingSecret ? (
            <div className="border border-gray-200 rounded-md p-4 flex flex-col gap-3">
              <div>
                <label className="block text-sm font-medium mb-1">Credencial</label>
                <Typography variant="body2" className="text-gray-500">
                  🔒 Credencial guardada y oculta por seguridad. Se conservará sin
                  cambios a menos que la reemplaces por un valor nuevo.
                </Typography>
              </div>
              <div>
                <DefaultButton
                  type="button"
                  color="secondary"
                  onClick={handleReplaceSecret}
                >
                  Reemplazar credencial
                </DefaultButton>
              </div>
            </div>
          ) : (
            <>
              <SelectFieldControlled
                label="Tipo de Contenido"
                name="contentType"
                id="content-type"
                control={control}
                options={contentTypeOptions}
                value={contentType}
                onChange={(e) => setContentType(e.target.value)}
              />

              {contentType === "object" ? (
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Contenido (JSON)
                  </label>
                  <textarea
                    name="content"
                    id="setting-content"
                    rows={8}
                    className="w-full border border-gray-300 rounded-md p-3 font-mono text-sm"
                    placeholder='{"key": "value", "nested": {"data": true}}'
                    {...control.register("content")}
                  />
                  {errors.content && (
                    <p className="text-red-500 text-sm mt-1">{errors.content.message}</p>
                  )}
                  <p className="text-gray-500 text-sm mt-1">
                    Ingrese un objeto JSON válido
                  </p>
                </div>
              ) : (
                <TextFieldControlled
                  label={replaceSecret ? "Nueva credencial" : "Contenido"}
                  placeholder={
                    contentType === "number" ? "Ej: 30" :
                    contentType === "boolean" ? "true o false" :
                    "Ej: sk-1234567890"
                  }
                  name="content"
                  id="setting-content"
                  control={control}
                  type={isSensitiveKey && !showValue ? "password" : "text"}
                  error={errors.content?.message}
                  helperText={
                    replaceSecret ? "Ingresa el valor completo de la nueva credencial" :
                    contentType === "boolean" ? "Ingrese 'true' o 'false'" :
                    contentType === "number" ? "Ingrese solo números" :
                    "El valor se guardará como texto"
                  }
                />
              )}

              {isSensitiveKey && contentType !== "object" && (
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="show-value"
                    checked={showValue}
                    onChange={(e) => setShowValue(e.target.checked)}
                    className="w-4 h-4"
                  />
                  <label htmlFor="show-value" className="text-sm">
                    Mostrar valor
                  </label>
                </div>
              )}

              {isEditMode && isSensitiveKey && replaceSecret && (
                <button
                  type="button"
                  onClick={handleCancelReplaceSecret}
                  className="text-sm text-gray-500 underline self-start"
                >
                  Cancelar reemplazo (conservar la credencial actual)
                </button>
              )}
            </>
          )}
        </ContentWrappers>

        <ContentWrappers gridColums={["1fr 1fr"]} className="gap-4 mt-8">
          <DefaultButton
            type="button"
            color="third"
            onClick={() => window.history.back()}
          >
            Cancelar
          </DefaultButton>
          <DefaultButton type="submit" color="secondary">
            {isEditMode ? "Actualizar" : "Crear"}
          </DefaultButton>
        </ContentWrappers>
      </form>
    </div>
  );
};

export default SettingsCreate;
